import { Box, Text } from 'roo-ui/components';

const GridDataCell = ({ label, value, isFirst, isLast, ...otherProps }) => (
  <Box
    mt={[isFirst ? 0 : 2, 6]}
    mb={[isLast ? 0 : 2, 6]}
    pb={[isLast ? 0 : 4, 0]}
    width={['100%', 1 / 3]} // 100% width for small screens, 33.33% for medium and up
    borderBottom={isLast ? 0 : [1, 0]}
    borderColor="greys.alto"
    {...otherProps}
  >
    <Text as="div" mb={0} color="greys.steel">
      {label}
    </Text>
    <Text as="div" mb={0} fontSize="lg">
      {value}
    </Text>
  </Box>
);

export default GridDataCell;
